var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.03 11.915a1.155 1.155 0 0 0-1.637 0l-1.845 1.845c-.855-.255-2.451-.834-3.463-1.845-1.012-1.012-1.59-2.608-1.845-3.464l1.845-1.845a1.157 1.157 0 0 0 0-1.637L5.455.34a1.156 1.156 0 0 0-1.637 0L.678 3.48A2.313 2.313 0 0 0 0 5.139c.027 1.649.463 7.374 4.975 11.886C9.488 21.537 15.213 21.972 16.863 22h.032c.611 0 1.189-.24 1.626-.678l3.14-3.14a1.157 1.157 0 0 0 0-1.636l-4.63-4.631Zm-.147 7.769c-1.444-.024-6.387-.412-10.27-4.297-3.897-3.896-4.274-8.856-4.298-10.272l2.321-2.32L7.63 5.787 6.133 7.284a1.157 1.157 0 0 0-.315 1.056c.028.133.707 3.29 2.629 5.211 1.922 1.922 5.078 2.601 5.211 2.629a1.147 1.147 0 0 0 1.056-.314l1.498-1.496 2.993 2.993-2.322 2.32Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-phone_svg__a",
    x: 0,
    y: 0,
    width: 22,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.244444 0 0 0 0 0.366667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1713_46230"
  })))));
};
export default SvgIconPhone;